import { Td, Tr } from '@chakra-ui/react'

export type DetailsItem = {
  name: string
  value: string
}

export const TableDetailsItem = ({ name, value }: DetailsItem) => {
  return (
    <Tr fontSize={{ base: '1rem', md: '1.25rem' }}>
      <Td fontWeight={700} color="gray.600">
        {name}
      </Td>
      <Td color="gray.700" isNumeric>
        {value}
      </Td>
    </Tr>
  )
}
